import Vue from 'vue'
import App from './app.js'
import VueRouter from 'vue-router'
import FastClick from 'fastclick'
import router from '@/router'

import store from './store/index'
import wxPlugin from './plugins/wx/index'
import httpPlugin from './plugins/request/index'
import storagePlugin from './plugins/storage/index'
import logoloadingPlugin from './plugins/loading/index'
import audioPlugin from './plugins/audio/index'
import statisticsPlugin from './plugins/statistics/index'

import XInput from 'vux/src/components/x-input'
import Calendar from 'vux/src/components/calendar'
import ConfirmPlugin from 'vux/src/plugins/confirm'
import ToastPlugin from 'vux/src/plugins/toast'
import LoadingPlugin from 'vux/src/plugins/loading'
import DatetimePlugin from 'vux/src/plugins/datetime'

import 'normalize.css'
import '@/common/style/index.styl'
import '@/common/style/animate.styl'

Vue.component('x-input', XInput)
Vue.component('calendar', Calendar)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)

const httpPluginConfig = {
  /* eslint-disable-next-line */
  errorHandler(errorType, err) {
    if (errorType === 'normalError') {
      // do nothing
      return false
    }
  }
}

router.beforeEach((to, from, next) => {
  const { name, query, params } = to
  if (name !== 'home') {
    if (!store.state.hasInit) {
      return next({name: 'home', query, params})
    }
  }
  next()
})

Vue.use(httpPlugin, httpPluginConfig)
Vue.use(wxPlugin)
Vue.use(storagePlugin)
Vue.use(logoloadingPlugin)
Vue.use(audioPlugin)
Vue.use(statisticsPlugin)
Vue.use(DatetimePlugin)

FastClick.attach(document.body)

Vue.use(VueRouter)
Vue.config.productionTip = false

new Vue(App).$mount('#app')